import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  Row,
  Select,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import { postInboundApiConfig } from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";

class InboundApiConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inboundApiConfigData: {},
      isLoadingData: false,
      isLoading: false,
      randomizationData: null,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.inboundApiConfigData.is_configured !==
      this.props.inboundApiConfigData.is_configured
    ) {
      this.setData();
    }
  }

  setData = () => {
    this.setState({
      inboundApiConfigData: this.props.inboundApiConfigData,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      const data = { ...values };

      this.props.form.setFields({
        qi_sign_before_staff: {
          value: values.qi_sign_before_staff,
          errors: null,
        },
      });
      this.props.form.setFields({
        qi_sign_after_staff: {
          value: values.qi_sign_after_staff,
          errors: null,
        },
      });

      try {
        await postInboundApiConfig(data);
        message.success(this.props.i18n.t("Saved"));
        this.props.setAppSettings();
        this.props.onSubmit();
      } catch (e) {
        if (get(e, "response.data.errors")) {
          const errors = {};
          Object.keys(get(e, "response.data.errors")).forEach(
            (errorFieldKey) => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                  (errorMessage) => new Error(errorMessage)
                ),
              };
            }
          );
          this.props.form.setFields(errors);
        } else {
          this.setState({
            errorMessage: JSON.stringify(get(e, "response.data.errors")),
          });
        }
        message.error(this.props.i18n.t("Error"));
        console.log(e);
      }
    });
  };

  render() {
    const {
      inboundApiConfigData,
      isLoading,
      isLoadingData,
      errorMessage,
    } = this.state;
    const { randomizationData, isDisabled } = this.props;
    const { getFieldDecorator } = this.props.form;
    const isRandomizeConfig =
      get(randomizationData, "treatment_groups", []).length > 0;
    const isEditable = isRandomizeConfig;

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">{this.props.i18n.t("NamespaceWizardConfig:Inbound API configs")}:</h3>

        {!isLoadingData ? (
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={8}>
              <Col sm={24}>
                {!isRandomizeConfig && (
                  <Alert
                    type="warning"
                    message={this.props.i18n.t(
                      "NamespaceWizardConfig:Please fill Randomization Config first"
                    )}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    <div>
                      {getFieldDecorator("allow_access_to_inbound_apis", {
                        initialValue: get(
                          inboundApiConfigData,
                          "allow_access_to_inbound_apis",
                          false
                        ),
                        valuePropName: "checked",
                      })(
                        <Checkbox disabled={!isEditable || isDisabled}>
                          <span style={{ fontSize: "16px" }}>
                            {this.props.i18n.t("NamespaceWizardConfig:Allow inbound APIs access to the DCTMS system via API keys")}
                          </span>
                        </Checkbox>
                      )}
                      <p>
                        <i>{this.props.i18n.t('NamespaceWizardConfig:Turning this setting ON will allow 3rd party api to log in and obtain a JWT via the "admin/api/login" endpoint, and open up the inbound API specific endpoints.')}</i>
                      </p>
                    </div>
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    <div>
                      {getFieldDecorator("allow_randomization_via_inbound_apis", {
                        initialValue: true,
                        valuePropName: "checked",
                      })(
                        <Checkbox disabled={true}>
                          <span style={{ fontSize: "16px" }}>
                            {this.props.i18n.t("NamespaceWizardConfig:Allow randomization via inbound APIs")}
                          </span>
                        </Checkbox>
                      )}
                      <p>
                        <i>{this.props.i18n.t('NamespaceWizardConfig:Turning this setting ON will allow 3rd party api to RANDOMIZE via the "/custom_forms/randomization-web". THIS SETTING SIS DISABLED FOR NOW.')}</i>
                      </p>
                    </div>
                  </Form.Item>
                </div>
              </Col>
            </Row>

            <Row gutter={8}>
              <Col lg={24}>
                <label>
                  <b>{this.props.i18n.t("NamespaceWizardConfig:Inbound api keys whitelist (CSV or keys or json list)")}:</b>
                  <Form.Item>
                    {getFieldDecorator("inbound_api_keys_whitelist", {
                      rules: [{ required: false, message: this.props.i18n.t("Required") }],
                      initialValue: get(
                          inboundApiConfigData,
                          "inbound_api_keys_whitelist",
                          ""
                        ),
                      })(<Input placeholder="" />)}
                    </Form.Item>
                  </label>
                </Col>
            </Row>

            <br />
            <Row gutter={8}>
              {errorMessage && (
                <Col span={24}>
                  <Alert message={errorMessage} type="error" />
                </Col>
              )}
              <Col span={24}>
                <Button
                  disabled={!isEditable || isDisabled}
                  type="primary"
                  size="large"
                  htmlType="submit"
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Icon type="loading" />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "InboundApiConfigForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(InboundApiConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/InboundApiConfigForm.js